export default __webpack_public_path__ + "8040d89973b3c5e6531f65dd3aa28fc2.png";